import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const LoginMiddle = () => import("@/views/login/login-middle.vue");
const QrCode = () => import("@/views/qrcode/index.vue");
const LinkDate = () => import("@/views/linkDate/index.vue");
const CustomerData = () => import("@/views/customerData/index.vue");
const launchWeapp = () => import("@/views/testLaunchWeapp/index.vue");

const routes = [
  {
    path: "/",
    name: "LoginMiddle",
    component: LoginMiddle,
    exact: true,
    meta: {
      title: "欢迎光临",
    },
  },
  {
    path: "/login-middle",
    name: "LoginMiddle",
    component: LoginMiddle,
    meta: {
      title: "欢迎光临",
    },
  },
  {
    path: "/qr-code",
    name: "QrCode",
    component: QrCode,
    meta: {
      title: "欢迎光临",
    },
  },
  {
    path: "/link-date",
    name: "LinkDate",
    component: LinkDate,
    meta: {
      title: "欢迎光临",
    },
  },
  {
    path: "/customer-data",
    name: "CustomerData",
    component: CustomerData,
    meta: {
      title: "欢迎光临",
    },
  },
  {
    path: "/launch-weapp",
    name: "launchWeapp",
    component: launchWeapp,
    meta: {
      title: "欢迎光临",
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: "/welcome/",
  routes,
});

export default router;
